import zipCodesServiceGen from "./generated/zipCodesServiceGen";

class zipCodesService extends zipCodesServiceGen {
}

export default zipCodesService;